import { z } from "zod";
import {
  ADDRESS,
  CLIENT_NAME,
  DESCRIPTION,
  ESTIMATED_END_DATE,
  ESTIMATED_START_DATE,
  NAME,
  PROJECT_CATEGORY_ID,
  PROJECT_CODE,
  PROJECT_ID,
  PROJECT_VALUE,
  STATUS,
} from "./consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [PROJECT_ID]: z.string().optional(),
  [PROJECT_CODE]: z.string().optional(),
  [PROJECT_CATEGORY_ID]: z.string().min(1, "This field is required"),
  [ESTIMATED_START_DATE]: z.any().optional(),
  [ESTIMATED_END_DATE]: z.any().optional(),
  [CLIENT_NAME]: z.string().optional(),
  [PROJECT_VALUE]: z.string().optional(),
  [ADDRESS]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
  [STATUS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
